<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-input v-model="args['item.no']" clearable placeholder="placeholder.pleaseEnterItemNo" @clear="refresh()" @keydown.native.enter="refresh()"/>
        <vxe-input v-model="args['item.name']" clearable placeholder="placeholder.pleaseEnterItemName" @clear="refresh()" @keydown.native.enter="refresh()"/>
        <vxe-input v-model="args['lot.no']" clearable placeholder="placeholder.pleaseEnterLotNo" @clear="refresh()" @keydown.native.enter="refresh()"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh()"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="250"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="150"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
        <vxe-column field="asnDetail.manufacturer" title="business.label.manufacturer" width="200"/>
        <vxe-column field="asnDetail.producingArea" title="business.label.producingArea" width="100"/>
        <vxe-column field="asnDetail.lotNo" title="business.label.lot" width="150"/>
        <vxe-column field="asnDetail.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="asnDetail.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="asnDetail.approvalNo" title="business.label.approvalNo" width="150"/>
        <vxe-column field="asnDetail.quantity" title="business.label.invoiceQuantity" width="150"/>
        <vxe-column :title="refundable?'business.label.returnAcceptQuantity':'business.label.receivedQuantity'" field="asnDetail.receivedQuantity" width="150"/>
        <vxe-column :title="refundable? 'business.label.returnRejectQuantity':'business.label.rejectedQuantity'" field="asnDetail.rejectedQuantity" width="150"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="business.label.receiving" icon="vxe-icon-association-form" status="primary" @click.stop="receive(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import { AsnOrder } from '@/api/dto/order/AsnOrder'

export default {
  name: 'ReceiptDetail',
  data() {
    return {
      loading: false,
      data: [],
      order: new AsnOrder(),
      args: {
        'item.no': '',
        'item.name': '',
        'lot.no': ''
      },
      page: 1,
      size: 15,
      contentSize: 0
    }
  },
  props: {
    refundable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = {
        ...this.args,
        'order.id': this.order.id,
        aggregate: true
      }
      findAll('asnDetailFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh(order) {
      if (order) this.order = order
      this.page = 1
      this.fetch()
    },
    reset() {
      this.args = {
        'item.no': '',
        'item.name': '',
        'lot.no': ''
      }
      this.refresh()
    },
    clear() {
      this.data = []
    },
    receive(row) {
      if (row.dimension.length === 0 && row.dimension.width === 0 && row.dimension.height === 0) {
        this.$message.warning('包装长宽高未维护')
        return
      }
      row.order = this.order
      this.$emit('receive', row)
    }
  }
}
</script>